import React , {useRef, useEffect, useState } from "react";
import { Helmet } from 'react-helmet-async';
const Main = ({ title, description }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true); // Trigger fade-in effect
  }, []);
  return (
    <>
      <>
      <Helmet>
    <title>{title || 'EnbyBase Official Website'}</title>
    <meta name="description" content={description || 'EnbyBase • TransBase Official Website'} />
    <meta property="og:title" content={title || 'EnbyBase Official Website'} />
    <meta property="og:description" content={description || 'EnbyBase • TransBase Official Website'} />
  </Helmet>
      <div className="mainintrop">
      <div
        className="search-banner"
        style={{
          background:
            'url("../public/horizontal-line.png") calc(13.1% - 6.25rem) 80% / calc(28% - 6.25rem) no-repeat, url("../public/horizontal-line.png") calc(100% - 6.1rem) 10% / calc(28% - 6.25rem) no-repeat, url("../public/gradiant-for-hero.png") 100% 0px / contain no-repeat',
          padding: "0px 8.5rem",
          overflow: "hidden",
          boxSizing: "border-box",
          height: "calc(-5.625rem + 100vh)",
          textAlign: "start",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center"
        }}
      >
        <h2 className="gradient-text" id="searchHeader"
          style={{
            overflow: "hidden",
            margin: "0px",
            whiteSpace: "break-spaces",
            color: "rgb(255, 255, 255)",
            fontSize: "3.75rem",
            fontFamily: '"Simpler Black"',
            lineHeight: "5rem",
            maxWidth: "50.125rem",
            position: "relative",
            top: '-80px',
            fontFamily: 'FoundryContextW03Bd'
          }}
        >
          World Class Non-Binary Discord Server,
          EnbyBase.
          <br />
        <button
                  className="main11b" style={{top: '10px'}}
                >
                  <div
                    className="flex grow justify-center max-w-full"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "currentcolor",
                      boxSizing: "border-box",
                      display: "flex",
                      maxWidth: "100%",
                      flexGrow: 1,
                      justifyContent: "center",
                    }}
                  >
                    <span
                      className="transition-all duration-200 whitespace-nowrap text-ellipsis overflow-hidden block w-full shrink-0 text-center"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "currentcolor",
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%",
                        flexShrink: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "center",
                        transitionProperty: "all",
                        transitionTimingFunction:
                          "cubic-bezier(0.4, 0, 0.2, 1)",
                        transitionDuration: "0.2s",
                        
                      }}
                    >
                      <div
                        className="flex items-center gap-2 justify-center"
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "currentcolor",
                          boxSizing: "border-box",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <svg
                          className="text-dark-100 w-5"
                          height="24"
                          width="24"
                          fill="none"
                          viewBox="0 0 18 13"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            borderWidth: "0px",
                            borderStyle: "solid",
                            borderColor: "currentcolor",
                            boxSizing: "border-box",
                            display: "block",
                            verticalAlign: "middle",
                            width: "1.25rem",
                            color: "#FFFFFF",
                          }}
                        >
                          <path
                            d="M15.248 1.089A15.431 15.431 0 0011.534 0a9.533 9.533 0 00-.476.921 14.505 14.505 0 00-4.12 0A9.582 9.582 0 006.461 0a15.54 15.54 0 00-3.717 1.091C.395 4.405-.242 7.636.076 10.821A15.269 15.269 0 004.631 13c.369-.473.695-.974.975-1.499a9.896 9.896 0 01-1.536-.699c.13-.089.255-.18.377-.27 1.424.639 2.979.97 4.553.97 1.574 0 3.129-.331 4.553-.97.123.096.25.188.377.27a9.94 9.94 0 01-1.54.7c.28.525.607 1.026.976 1.498a15.2 15.2 0 004.558-2.178c.373-3.693-.639-6.895-2.676-9.733zM6.01 8.862c-.888 0-1.621-.767-1.621-1.712 0-.944.708-1.718 1.618-1.718.91 0 1.638.774 1.623 1.718-.016.945-.715 1.712-1.62 1.712zm5.98 0c-.889 0-1.62-.767-1.62-1.712 0-.944.708-1.718 1.62-1.718.912 0 1.634.774 1.618 1.718-.015.945-.713 1.712-1.618 1.712z"
                            fill="currentColor"
                            style={{
                              borderWidth: "0px",
                              borderStyle: "solid",
                              borderColor: "currentcolor",
                              boxSizing: "border-box",
                            }}
                          />
                        </svg><a href="https://dsc.gg/enbybase" style={{textDecoration: 'none', color: '#FFFFFF', fontFamily:'FoundryContextW03Demi' }}>
                        Join EnbyBase Discord</a>
                      </div>
                    </span>
                  </div>
                </button>
                <button
                  className="main11btransgender" style={{top: '30px'}}
                >
                  <div
                    className="flex grow justify-center max-w-full"
                    style={{
                      borderWidth: "0px",
                      borderStyle: "solid",
                      borderColor: "currentcolor",
                      boxSizing: "border-box",
                      display: "flex",
                      maxWidth: "100%",
                      flexGrow: 1,
                      justifyContent: "center",
                    }}
                  >
                    <span
                      className="transition-all duration-200 whitespace-nowrap text-ellipsis overflow-hidden block w-full shrink-0 text-center"
                      style={{
                        borderWidth: "0px",
                        borderStyle: "solid",
                        borderColor: "currentcolor",
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%",
                        flexShrink: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "center",
                        transitionProperty: "all",
                        transitionTimingFunction:
                          "cubic-bezier(0.4, 0, 0.2, 1)",
                        transitionDuration: "0.2s",
                        
                      }}
                    >
                      <div
                        className="flex items-center gap-2 justify-center"
                        style={{
                          borderWidth: "0px",
                          borderStyle: "solid",
                          borderColor: "currentcolor",
                          boxSizing: "border-box",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <svg
                          className="text-dark-100 w-5"
                          height="24"
                          width="24"
                          fill="none"
                          viewBox="0 0 18 13"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            borderWidth: "0px",
                            borderStyle: "solid",
                            borderColor: "currentcolor",
                            boxSizing: "border-box",
                            display: "block",
                            verticalAlign: "middle",
                            width: "1.25rem",
                            color: "#FFFFFF",
                          }}
                        >
                          <path
                            d="M15.248 1.089A15.431 15.431 0 0011.534 0a9.533 9.533 0 00-.476.921 14.505 14.505 0 00-4.12 0A9.582 9.582 0 006.461 0a15.54 15.54 0 00-3.717 1.091C.395 4.405-.242 7.636.076 10.821A15.269 15.269 0 004.631 13c.369-.473.695-.974.975-1.499a9.896 9.896 0 01-1.536-.699c.13-.089.255-.18.377-.27 1.424.639 2.979.97 4.553.97 1.574 0 3.129-.331 4.553-.97.123.096.25.188.377.27a9.94 9.94 0 01-1.54.7c.28.525.607 1.026.976 1.498a15.2 15.2 0 004.558-2.178c.373-3.693-.639-6.895-2.676-9.733zM6.01 8.862c-.888 0-1.621-.767-1.621-1.712 0-.944.708-1.718 1.618-1.718.91 0 1.638.774 1.623 1.718-.016.945-.715 1.712-1.62 1.712zm5.98 0c-.889 0-1.62-.767-1.62-1.712 0-.944.708-1.718 1.62-1.718.912 0 1.634.774 1.618 1.718-.015.945-.713 1.712-1.618 1.712z"
                            fill="currentColor"
                            style={{
                              borderWidth: "0px",
                              borderStyle: "solid",
                              borderColor: "currentcolor",
                              boxSizing: "border-box",
                            }}
                          />
                        </svg><a href="https://dsc.gg/transbase" style={{textDecoration: 'none', color: '#FFFFFF', fontFamily:'FoundryContextW03Demi' }}>
                        Join TransBase Discord</a>
                      </div>
                    </span>
                  </div>
                </button>
        </h2>
        <div className="video-gradient left"></div>
        <iframe
          id="videoBackground"
          title="videoBackground"
          src="https://www.youtube-nocookie.com/embed/LbWeeX8nSXo?autoplay=1&rel=0&loop=1&mute=1&controls=0&modestbranding=1&playlist=LbWeeX8nSXo"
          
          frameborder="0"
          style={{
            insetInline: "0px",
            border: "0px",
            width: "100vw",
            height: "116vh",
            position: "absolute",
            top: "-150px",
            marginTop: '0px',
            marginBottom: '0px',
            zIndex: -2,
            objectFit: "cover",
            margin: 0,
            padding: 0,
            display: 'block',
            overflow: 'hidden',
          }}
        /><div className="video-gradient right"></div>
      </div></div>






      <ul
        className="news__list"
        style={{
          boxSizing: "inherit",
          gap: "16px 0px",
          listStyle: "none",
          margin: "0px",
          padding: "25px",
          display: "grid",
          gridTemplateColumns:
            "48.913% 6.41304% 19.1304% 2.17391% 19.1304% 4.23913%",
          gridTemplateRows: "repeat(2, minmax(16.5217%, auto))",
          background:
            "linear-gradient(315deg, rgb(0,0,0) 0%, rgb(7, 7, 14) 20%, rgb(14, 14, 28) 40%, rgb(21, 21, 42) 60%, rgb(28, 28, 56) 80%, rgb(35, 35, 70) 100%)",
          
        }}
      >
        <li
          className="news__tile"
          style={{ boxSizing: "inherit", gridArea: "1 / 1 / span 2" }}
        >
          <a
            href="https://dsc.gg/enbybase"
            style={{
              boxSizing: "inherit",
              backgroundColor: "initial",
              textDecoration: "none",
              color: "rgb(255, 255, 255)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="news__decor"
              style={{
                boxSizing: "inherit",
                display: "flex",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "100%",
                paddingBottom: "4px",
              }}
            >
            </div>
            <div
              className="news__image"
              style={{
                boxSizing: "inherit",
                gap: "4px",
                display: "flex",
                flexDirection: "column",
                position: "relative",
              }}
            >
              <img
                itemProp="image"
                src="https://firebasestorage.googleapis.com/v0/b/enbybase.appspot.com/o/cdn2%2Fsdwbb1.JPG?alt=media&token=28a14af9-078b-4fe6-9e8c-a5e5b3a78cd8"
                style={{
                  boxSizing: "inherit",
                  borderStyle: "none",
                  aspectRatio: "16 / 9",
                  display: "block",
                  maxHeight: "100%",
                  maxWidth: "100%",
                  opacity: visible ? 1 : 0,
          transition: 'opacity 1s ease-in-out',
                }}
              />
              <div
                className="news__image-title"
                style={{
                  boxSizing: "inherit",
                  background:
                    "linear-gradient(transparent, rgba(0, 0, 0, 0.61) 39.07%, rgb(0, 0, 0))",
                  padding: "0px 32px 32px",
                  alignItems: "flex-end",
                  bottom: "0px",
                  color: "#9C59D1",
                  display: "flex",
                  height: "239px",
                  position: "absolute",
                  width: "100%",
                }}
              >
                <h3
                  className="h2"
                  style={{
                    boxSizing: "inherit",
                    margin: "0px",
                    padding: "0px",
                    fontFamily: "FoundryContextW03Demi, sans-serif",
                    fontWeight: 700,
                    fontSize: "48px",
                    fontStyle: "normal",
                    lineHeight: "100%",
                  }}
                >
                  Join our Discord server!
                </h3>
              </div>
            </div>
            <div
              className="news__excerpt body"
              style={{
                boxSizing: "inherit",
                fontFamily: "BlenderProBook, sans-serif",
                fontWeight: 400,
                fontSize: "20px",
                fontStyle: "normal",
                lineHeight: "120%",
                overflow: "hidden",
                padding: "20px 32px 0px",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
                display: "-webkit-box",
                height: "72px",
                textOverflow: "ellipsis",
              }}
            />
          </a>
        </li>
        <li
          className="news__tile"
          style={{ boxSizing: "inherit", gridArea: "1 / 3" }}
        >
          <a
            href="https://discord.com/channels/1175757068779663410/1184090989284048896"
            style={{
              boxSizing: "inherit",
              backgroundColor: "initial",
              textDecoration: "none",
              color: "rgb(255, 255, 255)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="news__image"
              style={{
                boxSizing: "inherit",
                gap: "4px",
                display: "flex",
                flexDirection: "column",
                position: "relative",
              }}
            >
              <img
                itemProp="image"
                src="https://firebasestorage.googleapis.com/v0/b/enbybase.appspot.com/o/cdn2%2Fsdwbb2.JPG?alt=media&token=8da9de05-4e1f-4b4e-9f2d-1c85d12d9e00"
                style={{
                  boxSizing: "inherit",
                  borderStyle: "none",
                  aspectRatio: "16 / 9",
                  display: "block",
                  maxHeight: "100%",
                  maxWidth: "100%",
                  opacity: visible ? 1 : 0,
          transition: 'opacity 1.25s ease-in-out',
                }}
              />
            </div>
            <h3
              className="news__title"
              style={{
                boxSizing: "inherit",
                margin: "0px",
                padding: "0px",
                fontFamily: "FoundryContextW03Demi, sans-serif",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "110%",
                paddingTop: "12px",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              Support • Venting<br />Channels
            </h3>
          </a>
        </li>
        <li
          className="news__tile"
          style={{ boxSizing: "inherit", gridArea: "1 / 5" }}
        >
          <a
            href="https://discord.com/channels/1175757068779663410/1193511890509377577"
            style={{
              boxSizing: "inherit",
              backgroundColor: "initial",
              textDecoration: "none",
              color: "rgb(255, 255, 255)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="news__image"
              style={{
                boxSizing: "inherit",
                gap: "4px",
                display: "flex",
                flexDirection: "column",
                position: "relative",
              }}
            >
              <img
                itemProp="image"
                src="https://firebasestorage.googleapis.com/v0/b/enbybase.appspot.com/o/cdn2%2Fsdwbb3.JPG?alt=media&token=a90d3278-a2f4-40e7-b4ae-1d49833f2d33"
                style={{
                  boxSizing: "inherit",
                  borderStyle: "none",
                  aspectRatio: "16 / 9",
                  display: "block",
                  maxHeight: "100%",
                  maxWidth: "100%",
                  opacity: visible ? 1 : 0,
          transition: 'opacity 1.5s ease-in-out',
                }}
              />
            </div>
            <h3
              className="news__title"
              style={{
                boxSizing: "inherit",
                margin: "0px",
                padding: "0px",
                fontFamily: "FoundryContextW03Demi, sans-serif",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "110%",
                paddingTop: "12px",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              Multilingual<br />Support
            </h3>
          </a>
        </li>
        <li
          className="news__tile"
          style={{ boxSizing: "inherit", gridArea: "2 / 3" }}
        >
          <a
            href="https://discord.com/channels/1175757068779663410/1186284012059230268"
            style={{
              boxSizing: "inherit",
              backgroundColor: "initial",
              textDecoration: "none",
              color: "rgb(255, 255, 255)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="news__image"
              style={{
                boxSizing: "inherit",
                gap: "4px",
                display: "flex",
                flexDirection: "column",
                position: "relative",
              }}
            >
              <img
                itemProp="image"
                src="https://firebasestorage.googleapis.com/v0/b/enbybase.appspot.com/o/cdn2%2Fsdwbb4.JPG?alt=media&token=8382a4df-63b0-4f08-93a7-69916abc9b76"
                style={{
                  boxSizing: "inherit",
                  borderStyle: "none",
                  aspectRatio: "16 / 9",
                  display: "block",
                  maxHeight: "100%",
                  maxWidth: "100%",
                  opacity: visible ? 1 : 0,
          transition: 'opacity 1.75s ease-in-out',
                }}
              />
            </div>
            <h3
              className="news__title"
              style={{
                boxSizing: "inherit",
                margin: "0px",
                padding: "0px",
                fontFamily: "FoundryContextW03Demi, sans-serif",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "110%",
                paddingTop: "12px",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              Travel<br />Community
            </h3>
          </a>
        </li>
        <li
          className="news__tile"
          style={{ boxSizing: "inherit", gridArea: "2 / 5" }}
        >
          <a
            href="/transbase"
            style={{
              boxSizing: "inherit",
              backgroundColor: "initial",
              textDecoration: "none",
              color: "rgb(255, 255, 255)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="news__image"
              style={{
                boxSizing: "inherit",
                gap: "4px",
                display: "flex",
                flexDirection: "column",
                position: "relative",
              }}
            >
              <img
                itemProp="image"
                src="https://firebasestorage.googleapis.com/v0/b/enbybase.appspot.com/o/cdn2%2Fsdwbb5.JPG?alt=media&token=2883221d-e30b-4e83-aa63-2ba9e4f3fc32"
                style={{
                  boxSizing: "inherit",
                  borderStyle: "none",
                  aspectRatio: "16 / 9",
                  display: "block",
                  maxHeight: "100%",
                  maxWidth: "100%",
                  opacity: visible ? 1 : 0,
          transition: 'opacity 2s ease-in-out',
                }}
              />
            </div>
            <h3
              className="news__title"
              style={{
                boxSizing: "inherit",
                margin: "0px",
                padding: "0px",
                fontFamily: "FoundryContextW03Demi, sans-serif",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "110%",
                paddingTop: "12px",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              TransBase<br />Discord
            </h3>
          </a>
        </li>
      </ul>

            </> 
    </>
  );
}

export default Main;